import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
    addDate, formatDate
} from '@/common/timeformat'
const today = new Date()
export default {
    components:{
        "date-picker": DatePicker
    },
    methods: {
        notBeforeToday(date, range = 6) {
            return date < addDate(today,range);
        },
        formatDate(value){
            return formatDate(value)
        }
    }
}